/*
 * file: Layout/Index.jsx
 * 상세: 레이어아웃 모음
 */

import Head from "./Head"
import Footer from "./Footer"
import Sidbar from "./Sidbar"

import { Fnc } from "common/globals"

export default function Index({ children }) {
  return (
    <>
      {
        Fnc.CheckUser()
        ? <>
          <Head />
          <Sidbar />
          { children }
          <Footer />
        </>
        : children
      }
    </>
  )
}